import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName, setPropTypes } from 'recompose';
import classNames from 'classnames';
import FieldContainer from '../FieldContainer';
import Validation from '../Input/Validation';
import styles from './Checkbox.scss';

export const Checkbox = ({
  input, label, type, meta: { touched, error }, customProps = {},
}) => (
  <FieldContainer fullSize={customProps.fullSize}>
    <Validation
      touched={touched || customProps.touched}
      error={error}
      novalidate={customProps.novalidate}
      submitValidate={customProps.submitValidate}
      customError={customProps.error ? customProps.error.component : null}
        >
      <div
        className={classNames(
          styles.icon,
          { [styles.checked]: input.checked },
        )}
      />
      <label
        className={classNames(styles.label)}
        htmlFor={input.name}
      >
        {
                    label &&
                    <span className={styles.title}>{label}</span>
                }
        <span>{customProps.description}</span>
      </label>
      <input
        {...input}
        {...customProps.input}
        type={type}
        id={input.name}
        className={`${styles.checkbox} ui-checkbox_input`}
            />
    </Validation>
  </FieldContainer>
);

export default compose(
  setDisplayName('Checkbox'),
  setPropTypes({
    input: PropTypes.any.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    type: PropTypes.string.isRequired,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
    }).isRequired,
    customProps: PropTypes.object.isRequired,
  }),
)(Checkbox);
